import { render, staticRenderFns } from "./PersonalName.vue?vue&type=template&id=1e5dff8c&scoped=true&"
import script from "./PersonalName.vue?vue&type=script&lang=js&"
export * from "./PersonalName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5dff8c",
  null
  
)

export default component.exports